import {
  SET_HIDE_GO_TO_HY_EX,
  SET_COLLAPSE_SIDE_TEST_DRAWER,
  SET_IS_HEADER_BTN_INJECTED_BY_OTHER_PRODUCT,
  SET_DOCK_MODE,
} from '../actionTypeConstants/otherProductConfigConstants';

const initialState = {
  hideGoToHyEx: false,
  collapseSideTestDrawerForOtherProduct: false,
  isHeaderBtnInjectedByOtherProduct: false,
  dockMode: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_HIDE_GO_TO_HY_EX:
      return {
        ...state,
        hideGoToHyEx: action.payload,
      };

    case SET_COLLAPSE_SIDE_TEST_DRAWER:
      return {
        ...state,
        collapseSideTestDrawerForOtherProduct: action.payload,
      };

    case SET_IS_HEADER_BTN_INJECTED_BY_OTHER_PRODUCT:
      return {
        ...state,
        isHeaderBtnInjectedByOtherProduct: action.payload,
      };

    case SET_DOCK_MODE:
      return {
        ...state,
        dockMode: action.payload,
      };

    default:
      return state;
  }
}
